(() => {
  const CHART_READY_TIMEOUT_MS = 4000;
  const CHART_READY_POLL_MS = 150;

  const isCanvasBlank = (canvas) => {
    const blank = document.createElement('canvas');
    blank.width = canvas.width;
    blank.height = canvas.height;
    return canvas.toDataURL('image/png') === blank.toDataURL('image/png');
  };

  const waitForChartReady = (canvas) => {
    return new Promise((resolve) => {
      const start = Date.now();
      const check = () => {
        let blank = true;
        try {
          blank = isCanvasBlank(canvas);
        } catch (error) {
          resolve();
          return;
        }
        if (!blank || Date.now() - start >= CHART_READY_TIMEOUT_MS) {
          resolve();
          return;
        }
        setTimeout(check, CHART_READY_POLL_MS);
      };
      check();
    });
  };

  const IMAGE_LOAD_TIMEOUT_MS = 4000;

  const waitForImage = (image) => {
    if (image.complete) return Promise.resolve();

    return new Promise((resolve) => {
      const finish = () => {
        image.removeEventListener('load', finish);
        image.removeEventListener('error', finish);
        clearTimeout(timer);
        resolve();
      };
      image.addEventListener('load', finish, { once: true });
      image.addEventListener('error', finish, { once: true });
      const timer = setTimeout(finish, IMAGE_LOAD_TIMEOUT_MS);
    });
  };

  const waitForImages = (doc) => {
    const images = [...doc.querySelectorAll('img')];
    return Promise.all(images.map(waitForImage));
  };

  const initButton = (button) => {
    if (!button || button.dataset.productPrintReady === 'true') return;
    button.dataset.productPrintReady = 'true';

    const buildPrintDocument = async (template) => {
      const fragment = template.content.cloneNode(true);
      const chartWrappers = [...fragment.querySelectorAll('[data-chart-source-id]')];

      await Promise.all(
        chartWrappers.map((chartWrapper) => {
          const sourceId = chartWrapper.getAttribute('data-chart-source-id');
          const sourceCanvas = document.getElementById(sourceId);
          return sourceCanvas ? waitForChartReady(sourceCanvas) : Promise.resolve();
        })
      );

      chartWrappers.forEach((chartWrapper) => {
        const sourceId = chartWrapper.getAttribute('data-chart-source-id');
        const sourceCanvas = document.getElementById(sourceId);
        const image = chartWrapper.querySelector('img');

        if (!sourceCanvas || !image) {
          chartWrapper.remove();
          return;
        }

        try {
          image.src = sourceCanvas.toDataURL('image/png');
        } catch (error) {
          chartWrapper.remove();
        }
      });

      const emptyCharts = fragment.querySelector('[data-product-print-charts]');
      if (emptyCharts && emptyCharts.querySelectorAll('.product-print-sheet__chart').length === 0) {
        emptyCharts.remove();
      }

      const wrapper = document.createElement('div');
      wrapper.appendChild(fragment);
      return wrapper.innerHTML;
    };

    const openPrintWindow = async () => {
      const templateId = button.getAttribute('data-print-template-id');
      const template = document.getElementById(templateId);
      if (!template) return;

      const printWindow = window.open('', '_blank');
      if (!printWindow) return;

      printWindow.document.body.innerHTML = 'Preparing print preview…';

      const printMarkup = await buildPrintDocument(template);
      if (printWindow.closed) return;

      const documentTitle = button.getAttribute('data-print-document-title') || document.title;
      if (!printMarkup.trim()) {
        printWindow.close();
        return;
      }

      printWindow.document.title = documentTitle;
      printWindow.document.head.innerHTML = '<meta charset="utf-8"><title>' + documentTitle + '</title>';
      printWindow.document.body.innerHTML = printMarkup;

      await waitForImages(printWindow.document);
      if (printWindow.closed) return;

      printWindow.focus();
      printWindow.print();

      printWindow.addEventListener('afterprint', () => {
        printWindow.close();
      }, { once: true });
    };

    button.addEventListener('click', (event) => {
      if (button.dataset.productPrintTrigger === 'true') {
        event.preventDefault();
        event.stopPropagation();
      }
      openPrintWindow();
    });
  };

  document.querySelectorAll('[data-print-template-id]').forEach(initButton);
})();
